export default __webpack_public_path__ + "static/media/register-user-avatar.c985962c.svg";